var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTranslate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1836_15486)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.5 19L13.75 7.75L19 19M10 16H17.5M1 3.621C2.9904 3.37332 4.99425 3.24941 7 3.25M7 3.25C8.12 3.25 9.233 3.288 10.334 3.364M7 3.25V1M10.334 3.364C9.176 8.658 5.69 13.08 1 15.502M10.334 3.364C11.23 3.425 12.119 3.511 13 3.621M8.411 12.116C6.77097 10.4486 5.47113 8.47799 4.584 6.314",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1836_15486"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTranslate);
export default __webpack_public_path__ + "static/media/translate.ae697a9f5133917c845f9e7063c7e17b.svg";
export { ForwardRef as ReactComponent };